var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFeatureCheckSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#5FD889",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.429,
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#5FD889",
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.804 10.775 2.966 2.966 6.945-6.944"
}))));
export { SvgFeatureCheckSmall as ReactComponent };
export default __webpack_public_path__ + "img/feature-check-small.ac6ab37a83268e738ed4fc5425c864d3.svg";